import axios from "axios";
import router from "@/router";
import { useAuthStore } from "@/stores/auth";
import { showToast } from "vant";

const getBaseURL = () => {
  if (import.meta.env.MODE != "production") {
    return "https://delivery-api-dev-aus.xiaohuangxi.studio/";
  }
  return "https://delivery-api-aus.idirect.au/";
};

// 创建基础 Axios 实例
const createAxiosInstance = (baseURL = []) => {
  const instance = axios.create({
    baseURL, // API 基地址
    timeout: 100000, // 请求超时时间
    withCredentials: true, // 默认携带 Cookie
  });

  // 请求拦截器
  instance.interceptors.request.use(
    (config) => {
      const authStore = useAuthStore();
      const token = authStore.token;

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      if(__APP_VERSION__){
        config.headers['App-Version'] = `${__APP_VERSION__}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // 响应拦截器
  instance.interceptors.response.use(
    (response) => {
      // 检查通用业务逻辑
      const noRedirectPaths = ["/", "/driver/login", "/driver/sms-login", "/driver/register"];
      // 如果当前路由不是登录页，跳转到登录页
      const currentPath = router.currentRoute.value.path;
      console.log("当前路由:", currentPath);

      if (!noRedirectPaths.includes(currentPath)) {
        if (response.data && response.data.code === 401) {
          showToast("登录已过期");
          localStorage.removeItem("DRIVER-AUTH");
          router.push("/driver/login");
          window.location.reload();
          return Promise.reject(new Error(response.data.message || "登录已过期"));
        }

        if (response.data && response.data.code === 422) {
          showToast("账户未认证");
          router.push("/driver/verify");
          return Promise.reject(new Error(response.data.message || "账户未认证"));
        }
      }

      return response; // 正常返回
    },
    (error) => {
      if (error.response) {
        const message = error.response.data.message || "请求失败";
        console.error("Axios 错误响应:", error.response);
        return Promise.reject(new Error(message));
      } else {
        console.error("Axios 网络错误:", error);
        return Promise.reject(new Error("网络出现颠簸~"));
      }
    }
  );

  return instance;
};

const baseURL = getBaseURL();
export const driverAxios = createAxiosInstance(baseURL);
export const merchantAxios = createAxiosInstance(baseURL);
export const commonAxios = createAxiosInstance(baseURL);

export default {
  driverAxios,
  merchantAxios,
  commonAxios,
};
